export const DATA = {
    orderStatus: [
        // { value: 3, name: 'Chờ báo giá', color: '#9e5959', orderIndex: 1 },
        { value: 0, name: 'Chờ đặt cọc', color: 'red', orderIndex: 2 },
        { value: 2, name: 'Đã đặt cọc', color: 'green', orderIndex: 3 },
        { value: 5, name: 'Đã mua hàng', color: '#2bbae4', orderIndex: 4 },
        { value: 16, name: 'Shop phát hàng', color: '#f7819f', orderIndex: 5 },
        { value: 11, name: 'Nhập kho TQ', color: '#7a8498', orderIndex: 6 },
        { value: 12, name: 'Chuyển về VN', color: '#7a8498', orderIndex: 7 },
        { value: 7, name: 'Nhập kho VN', color: 'orange', orderIndex: 8 },
        { value: 9, name: 'Đã xuất kho', color: 'blue', orderIndex: 9 },
        { value: 13, name: 'Khiếu nại', title: 'Đã khiếu nại', color: '#9732f3', orderIndex: 10 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 11 },
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 12 },
    ],
    depositStatus: [
        { value: 16, name: 'Shop phát hàng', color: '#f7819f', orderIndex: 1 },
        { value: 11, name: 'Nhập kho TQ', color: '#7a8498', orderIndex: 2 },
        { value: 12, name: 'Chuyển về VN', color: '#7a8498', orderIndex: 3 },
        { value: 7, name: 'Nhập kho VN', color: 'orange', orderIndex: 4 },
        { value: 9, name: 'Đã xuất kho', color: 'blue', orderIndex: 5 },
        { value: 10, name: 'Hoàn thành', color: '#7a8498', orderIndex: 6 },
        { value: 1, name: 'Đơn hàng hủy', color: 'black', orderIndex: 7 },
    ],
    payserviceStatus: [
        { value: 1, name: 'Đơn hủy', color: 'black', orderIndex: 1 },
        { value: 2, name: 'Chờ báo giá', color: '#f7819f', orderIndex: 2 },
        { value: 3, name: 'Chờ thanh toán', color: '#afa22e', orderIndex: 3 },
        { value: 4, name: 'Đã thanh toán', color: 'orange', orderIndex: 4 },
        { value: 5, name: 'Hoàn thành', color: '#7a8498', orderIndex: 5 },
    ],
    paymentTypeList: [
        { value: 1, name: 'Trực tiếp', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Ví', color: '#0059b3', textColor: '#FFF' },
    ],
    paymentStatusList: [
        { value: 2, name: 'Đặt cọc', color: '#808080', textColor: '#000' },
        { value: 12, name: 'Nhận lại cọc', color: '#e63900', textColor: '#000' },
        { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
        { value: 10, name: 'Thanh toán ship', color: '#7a8498', textColor: '#FFF' },
    ],
    complainStatusList: [
        { value: 0, name: 'Đã hủy', color: 'black' },
        { value: 1, name: 'Chờ xử lý', color: 'red' },
        { value: 2, name: 'Đang xử lý', color: 'orange' },
        { value: 3, name: 'Đã xử lý', color: 'blue' },
    ],
    statusAction: [
        { text: 'Hủy đơn hàng', color: '#d9534f', orderStatus: [0, 2] },
        { text: 'Khiếu nại', color: '#9732f3', orderStatus: [9, 13] },
    ],
    statusRecharge: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' },
        { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
        { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
    ],
    statusWithdrawal: [
        { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
        { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
        { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
    ],
    walletTradeType: [
        { value: 1, name: 'Đặt cọc' },
        { value: 2, name: 'Nhận lại tiền đặt cọc' },
        { value: 3, name: 'Thanh toán hóa đơn' },
        { value: 4, name: 'Nạp tiền' },
        { value: 5, name: 'Rút tiền' },
        { value: 6, name: 'Hủy lệnh rút tiền' },
        { value: 7, name: 'Xử lý khiếu nại' },
        { value: 9, name: 'Voucher khách mới' },
    ],
    billOfLadingStatus: [
        // { value: 0, name: 'Chưa phát hàng', disabled: true, color: 'red', textColor: '#000' },
        { value: 1, name: 'Đang vận chuyển', disabled: false, color: 'black', textColor: '#FFF' },
        { value: 2, name: 'Đã về kho TQ', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 3, name: 'Đang chuyển về VN', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 4, name: 'Đã về kho VN', disabled: false, color: 'green', textColor: '#FFF' },
        { value: 5, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' },
    ],
    rechargeMethods: [
        // { value: 1, name: 'Vietinbank'},
        // { value: 2, name: 'Vietcombank', acc_name: 'NGUYEN THI HUYEN TRANG', acc_number: '9398553836'},
        { value: 3, name: 'BIDV', acc_name: 'VU DUY HAO', acc_number: '1991006498'},
        // { value: 4, name: 'AGRIBANK'},
        // { value: 5, name: 'Techcombank', acc_name: 'NGUYEN THI HUYEN TRANG', acc_number: '3398553836'},
        // { value: 6, name: 'ACB'},
        // { value: 7, name: 'VPbank'},
        // { value: 8, name: 'MBbank', acc_name: 'EVERLINK', acc_number: '123456789'},
        // { value: 9, name: 'VIB'},
        // { value: 10, name: 'SeaBank'},
        // { value: 11, name: 'MSB', acc_name: 'DUONG VAN ANH', acc_number: '12001010807936'},
    ],
    exportReceiptStatus: [
        { value: 0, name: 'Chưa xuất', color: '#e63900' },
        { value: 1, name: 'Đã xuất', color: '#0059b3' }
    ],
};
